class Education {
	id = null;
	application_id = null;
	school_name = '';
	date_from = null;
	date_to = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Education;
